import type {AsYouType} from 'libphonenumber-js/core';
import {COUNTRIES, PRIORITY_COUNTRIES_CODES} from '@time-webkit/all/utils/phone-codes/constants';

/**
 * Источник - https://github.com/taiga-family/maskito/blob/main/projects/phone/src/lib/masks/phone/utils/get-phone-template.ts
 * Дополнительно добавлена обработка шаблонов для приоритетных номеров
 */
export function getPhoneTemplate(
    formatter: AsYouType,
    value: string,
    separator: string,
): string {
    formatter.input(value.replaceAll(/[^\d+]/g, ''));

    const initialTemplate = formatter.getTemplate();
    const split = initialTemplate.split(' ');

    const countryCode = formatter.getCountry();
    const isPriorityCountry = countryCode ? PRIORITY_COUNTRIES_CODES.includes(countryCode) : false;
    const callingCode = COUNTRIES[countryCode as keyof typeof COUNTRIES]?.countryCallingCode;
    let template = initialTemplate;

    if (callingCode && isPriorityCountry) {
        if (callingCode.length === 1) {
            template = `xx (xxx) xxx${separator}xx${separator}xx`;
        }

        if (callingCode.length === 3) {
            template = `xxxx (xx) xxx${separator}xx${separator}xx`;
        }
    } else {
        template =
            split.length > 1 ? `${split.slice(0, 2).join(' ')} ${split.slice(2).join(separator)}` : `${initialTemplate}${value.startsWith('+') ? '' : 'x'}`;
    }

    formatter.reset();

    return template.trim();
}
